export const host = "https://gochat42.onrender.com";

export const registerRouter = `${host}/api/auth/signup`;
export const loginRouter = `${host}/api/auth/login`;
export const usersRouter = `${host}/api/auth/users`;
export const messageget = `${host}/api/auth/messages/`;
